<template>
  <div class="page">
    <van-tabs v-model="activeType" @change="changeActiveType" title-active-color="#408CF8" color="#408CF8">
      <van-tab title="全部" name="all"></van-tab>
      <van-tab title="待审核" name="0"></van-tab>
      <van-tab title="已通过" name="1"></van-tab>
      <van-tab title="未通过" name="2"></van-tab>
    </van-tabs>
    <van-list
        style="margin-top: 20px;"
        :error.sync="error"
        error-text="请求失败，点击重新加载"
        v-model="loading"
        :finished="finished"
        finished-text="已加载完毕"
        @load="loadData"
    >
      <div @click="handleClick(item)" v-for="item in list" :key="item.id" class="item">
        <div class="title"></div>
        <div class="content">
          <div class="content-item">
            <div>
              <van-icon name="clock-o"/>
              申请时间
            </div>
            <div>{{ item.createTime }}</div>
          </div>
          <div class="content-item">
            <div>
              <van-icon name="setting-o"/>
              申请状态
            </div>
            <div class="status">{{ item.applyStatus | applyStatusFilter }}</div>
          </div>
          <div class="content-item" v-if="item.dealDateTime">
            <div>
              <van-icon name="passed"/>
              办理时间
            </div>
            <div>{{ item.dealDateTime }}</div>
          </div>
          <template v-if="item.applyStatus === -1">
            <div class="content-item">
              <div style="width: 200px;">
                <van-icon name="close"/>
                取消原因
              </div>
              <div>{{ item.cancelRemark }}</div>
            </div>
          </template>
          <template v-if="item.applyStatus == 1 || item.applyStatus == 0">
            <van-divider></van-divider>
            <div>
              <div style="text-align: right;">
                <van-button size="small" v-if="item.applyStatus == 1" @click="handleClickDoc(item)"
                            style="margin-left: 8px;" type="primary">
                  下载文件
                </van-button>
                <van-button size="small" v-if="item.applyStatus == 0" @click="handleClickCancel(item)"
                            style="margin-left: 8px;" type="warning">
                  撤销申请
                </van-button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </van-list>
    <van-button @click="handleGoApply" style="position: fixed;bottom: 0;right: 0;left: 0;width: 100%;" type="info">
      去申请
    </van-button>
    <van-dialog v-model="showCancelDialog" title="取消申请" :showCancelButton="true" :before-close="handleCloseCancel">
      <div>
        <div></div>
        <van-field
            v-model.trim="cancelRemark"
            label-width="70px"
            required
            show-word-limit
            :maxlength="100"
            type="textarea"
            clearable
            placeholder="请填写取消原因"
            label="取消原因"
        />
      </div>
    </van-dialog>
  </div>
</template>
<style scoped="scoped">
.page {
  padding: 0 0px 55px 0;
  box-sizing: border-box;
}

.item {
  position: relative;
  display: flex;
  flex-direction: column;
  background-size: 100% 100%;
  box-sizing: border-box;
  padding: 10px 10px;
  background: #FFFFFF;
  box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  margin: 12px;
}

.item .title {
  font-size: 18px;
  margin-bottom: 10px;
  font-weight: 500;
}

.item .status {
  color: #1989fa;
}

.content {
  display: flex;
  font-size: 14px;
  flex-direction: column;
}

.content-item {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding: 3px;
}

#qrcode {
  width: 100%;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
<script>
import nativeApi from '@/utils/native-bridge';
import {certWorkList as getList, certWorkCancel as cancelApply} from '@/api/cert';
import {createFilter} from '@/utils/sys-dict.js';
import loadMixin from '@/mixin/mixin-load.js';
import {Dialog} from "vant";

export default {
  name: 'CertCenterWork',
  components: {},
  mixins: [loadMixin],
  filters: {
    applyStatusFilter: createFilter('certStatus')
  },
  data() {
    return {
      query: {
        limit: 10,
        page: 0
      },
      activeType: 'all',
      list: [],
      loading: false,
      finished: false,
      error: false,
      showCancelDialog: false,
      cancelRemark: '',
      apply: null
    };
  },
  methods: {
    changeActiveType() {
      this.refreshData();
    },
    handleClick(item) {
      if (item.linkUrl) {
        nativeApi.forwardPage({
          uri: item.linkUrl
        });
      }
    },
    handleClickDoc(item) {
      console.info(item)
      this.showErrorTip('模板未配置')
    },
    handleClickCancel(item) {
      Dialog.confirm({
        title: '温馨提示',
        message: '是否撤销该申请？',
        confirmButtonText: '继续取消'
      }).then(() => {
        this.showTip('请填写取消原因');
        this.apply = item;
        this.showCancelDialog = true;
      }).catch(() => {
        // on cancel
      });
    },
    handleCloseCancel(action, done) {
      if (action === 'cancel') {
        done();
        return;
      }
      if (!this.cancelRemark) {
        this.showErrorTip('请填写取消原因');
        done(false);
        return;
      }
      cancelApply({id: this.apply.id, cancelRemark: this.cancelRemark})
          .then(() => {
            this.showSuccessTip('处理成功');
            this.refreshData();
            done(true);
          })
          .catch(() => {
            done(false);
          });
    },
    refreshData() {
      this.list = [];
      this.loadData();
    },
    loadData() {
      this.loading = true;
      const request = {};
      if (this.activeType !== 'all') {
        request.applyStatus = this.activeType;
      }
      getList(request)
          .then(({data}) => {
            console.info(data)
            this.list = data || [];
            this.finished = true;
          })
          .catch(() => {
            this.error = true;
            this.loading = false;
          });
    },
    handleGoApply() {
      this.$router.push({
        path: '/cert-center-work-create'
      });
    }
  },
  created() {
    // this.loadData();
  }
};
</script>
